export default __webpack_public_path__ + "static/media/trr-drink-juicecocktail-blueberrybasil.a3d343cc.png";